// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"Sidebar_sidebarContainer__3cdq0","sidebarBase":"Sidebar_sidebarBase__364vI"};